const $win = $(window)
const $doc = $(document)
const TABLET_WIDTH = 1024
const MOBILE_WIDTH = 768

// Nav
$doc.on('click', '.js-nav a', function (e) {
  const $this = $(this)

  if ($this.siblings().length && $win.width() < TABLET_WIDTH) {
    if (!$this.siblings().is(':visible')) {
      e.preventDefault()

      $this.closest('.js-nav').addClass('is-expanded')
    }

    $this
      .next()
      .slideDown()
      .parent()
      .addClass('is-expanded')
      .siblings()
      .removeClass('is-expanded')
      .children('a')
      .next()
      .slideUp()
  }
})
